export default __webpack_public_path__ + "334dc39ea98dfbf6049d28d8edf10856.jpg";